<template>
    <div class="warpper padding-sm bg-white">
        <div class="flex align-center justify-between">
            <div class="page-title line-height">意见反馈</div>
            <div class="page-operate yellow" @click="delAllQuestion()">删除全部</div>
        </div>
        <empty v-if="noData" :type="0"/>
        <div class="flex flex-direction">
            <div class="item flex flex-direction justify-center" v-for="(item,index) in lists" :key="index">
                <div class="info flex flex-wrap align-center">
                    <div><span>{{item.company}}</span>的<span>{{item.name}}</span>反馈：</div>
                </div>
                <div class="title flex align-center"><i class="iconfont icon-wenti"></i>{{item.content}}</div>
                <div class="content" v-if="item.remark">
                    <i class="iconfont icon-wenda"></i>{{item.remark}}
                </div>
                <div class="item-operate">
                    <i class="el-icon-chat-dot-round" @click="replyMessage(item)" v-if="!item.remark"></i>
                    <i class="el-icon-delete margin-left" @click="deleteItem(item.id)"></i>
                </div>
            </div>
        </div>
        <el-pagination
          v-if="lists.length>0"
                class="page-all margin-top"
                background
                @current-change="init"
                :current-page.sync="page"
                :page-size="limit"
                layout="prev, pager, next, jumper"
                :total="total">
        </el-pagination>
        <reply-opinion-dialog :applyDialogVisible="applyDialogVisible" :id="cur_id" :info="cur_info"
                              @watchState="watchState"></reply-opinion-dialog>
    </div>
</template>

<script>
    import {getMessageList, delMessage} from '@/api/organiz'
    import ReplyOpinionDialog from "@/components/ReplyOpinionDialog.vue";
    import {zhDate} from "@/utils/utils";

    export default {
        name: "opinion",
        data() {
            return {
                lists: [],
                page: 1,
                limit: 10,
                total: 0,
                cur_info: '',
                cur_id: 0,
                applyDialogVisible: false,
              noData:false
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        created() {
            this.$emit('setIndex', [6, 2], '意见反馈')
            this.init()
        },
        components: {ReplyOpinionDialog},
        methods: {
            //  页面加载时请求
            async init() {
                let _data = await getMessageList(this.page, this.limit)
                if (_data.status === 200) {
                    _data.data.map(item => {
                        item.add_time = zhDate(item.add_time * 1000)
                    })
                    this.lists = _data.data
                    this.total = _data.count
                  this.noData = false
                }else {
                    this.lists = []
                    this.total = 0
                  this.noData = true
                }
            },
            replyMessage(data) {
                this.applyDialogVisible = true
                this.cur_info = data.remark
                this.cur_id = data.id
            },
            deleteItem(id) {
                this.$confirm("确定要删除此意见反馈吗", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.delMessage(id)
                })
            },
            delAllQuestion() {
                this.$confirm("确定要删除此页全部意见反馈吗", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    let id = this.lists.map(item => {
                        return item.id
                    }).join(',')
                    this.delMessage(id)
                })

            },
            async delMessage(id) {
                let _data = await delMessage(id)
                if (_data.status === 200) {
                    this.init()
                    this.$message.success(_data.msg)
                }
            },
            watchState(state) {
                if (state) this.init()
                this.applyDialogVisible = false;
            },
        }
        ,
        filters: {}
        ,
        watch: {}
        ,
    }
</script>

<style scoped lang="scss">
    .warpper {
        .item {
            width: 100%;
            background-color: #ffffff;
            box-shadow: 0 0 10px #666666;
            border-radius: 10px;
            margin-top: 20px;
            padding: 20px;
            .item-operate {
                display: none;
            }
            &:hover {
                position: relative;
                cursor: pointer;
                .item-operate {
                    position: absolute;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: #00000033;
                    border-radius: 10px;
                    i {
                        width: 80px;
                        height: 80px;
                        line-height: 80px;
                        border-radius: 80px;
                        text-align: center;
                        background: #ffffff;
                        color: #ed7d31;
                        font-size: 28px;
                        cursor: pointer;
                    }
                }
            }
            .info {
                font-size: 16px;
                color: #333333;
                span {
                    font-weight: bold;
                }
            }
            .title {
                min-height: 55px;
                background-color: #f3f7fb;
                border-radius: 10px;
                border: solid 1px #dae0e6;
                font-size: 18px;
                font-weight: bold;
                padding: 20px;
                color: #333333;
                margin-top: 10px;
                i {
                    font-size: 17px;
                    color: #0a2240;
                    margin-right: 12px;
                }
            }
            .content {
                width: 100%;
                background-color: #ffffff;
                border-radius: 10px;
                border: solid 1px #dae0e6;
                font-size: 16px;
                line-height: 26px;
                color: #6666;
                margin-top: 10px;
                padding: 20px;
                i {
                    font-size: 15px;
                    color: #ffb400;
                    margin-right: 12px;
                }
            }
        }
    }
</style>